// Реестр текущего выделения в списках. Списки публикуют сюда отмеченные строки,
// а виджеты оболочки (быстрая заметка) читают: если карточка не открыта, но строки
// выбраны — действие применяется к ним.
import { useEffect, useMemo } from 'react';
import { create } from 'zustand';

export type SelectionKind =
  | 'contact'
  | 'deal'
  | 'company'
  | 'task'
  | 'meeting'
  | 'document'
  | 'template';

export interface SelectionItem {
  id: string;
  label: string;
}

interface SelectionState {
  kind: SelectionKind | null;
  items: SelectionItem[];
  setSelection: (kind: SelectionKind, items: SelectionItem[]) => void;
  clear: () => void;
}

export const useSelectionStore = create<SelectionState>((set) => ({
  kind: null,
  items: [],
  setSelection: (kind, items) => set({ kind, items }),
  clear: () => set({ kind: null, items: [] }),
}));

export function useCurrentSelection(): { kind: SelectionKind | null; items: SelectionItem[] } {
  const kind = useSelectionStore((state) => state.kind);
  const items = useSelectionStore((state) => state.items);
  return { kind, items };
}

/**
 * Публикует выделение списка в общий реестр и очищает его при уходе со страницы,
 * чтобы выделение с одного экрана не «протекало» на другой.
 */
export function usePublishSelection(kind: SelectionKind, items: SelectionItem[]): void {
  const setSelection = useSelectionStore((state) => state.setSelection);
  const clear = useSelectionStore((state) => state.clear);
  // Сериализуем, чтобы эффект не срабатывал на каждый ре-рендер массива.
  const signature = items.map((item) => `${item.id}:${item.label}`).join('|');

  // Стабилизируем массив по сигнатуре: сам items — новый на каждый рендер
  // вызывающей страницы, и эффект срабатывал бы на каждое нажатие клавиши.
  const stableItems = useMemo(() => items, [signature]);

  useEffect(() => {
    setSelection(kind, stableItems);
  }, [kind, stableItems, setSelection]);

  useEffect(() => clear, [clear]);
}
